import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'avr-footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss'],
    standalone: false
})
export class FooterComponent implements OnInit {

  constructor() {
  }

  ngOnInit() {
  }

}
